import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    baseURL: 'https://psm-api.zennosys.com/',
    removeTitle: 'Uyarı!',
    removeMessage: 'Kayıt kalıcı olarak silinecektir! Devam etmek istiyor musunuz?',
    removeConfirm: 'Devam Et',
    removeCancel: 'Vazgeç',
    removeResultTitle: 'İşlem Başarılı!',
    removeResultMessage: 'Kayıt kalıcı olarak silinmiştir.!',
    removeResultClose: 'Kapat',
    recoveryTitle: 'Uyarı!',
    recoveryMessage: 'Silinen kayıt geri alınacaktır! Devam etmek istiyor musunuz?',
    recoveryConfirm: 'Devam Et',
    recoveryCancel: 'Vazgeç',
    recoveryResultTitle: 'İşlem Başarılı!',
    recoveryResultMessage: 'Silinen kayıt geri alındı.!',
    recoveryResultClose: 'Kapat',
    perPage: 20,
    isDownloading: false,
    listPages: {},
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    isDownloading(state) {
      return state.isDownloading
    },
  },
  mutations: {
    SET_DOWNLOADING(state, downloading) {
      state.isDownloading = downloading
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    SET_LIST_PAGE(state, { path, page }) {
      state.listPages = { ...state.listPages, [path]: page }
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {},
}
